import React, { Children, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import Block from '../../Block';
import { CustomSwitch, FormGroup, Icon, Select, useForm } from '../../components';
import get from 'lodash/get';
import { ListGroup } from 'react-bootstrap';
import {useParams} from "react-router-dom";
import { useGetDataVendorQuery } from '../../../api/dataVendorApiSlice';
import { usePropState } from '../../utils';
import { useGetPublishersQuery } from '../../../api/publisherApiSlice';
import styled from 'styled-components';

const BarableListItemSpaned = styled(ListGroup.Item)`
  ${props => props.bared === "true" ? `text-decoration: line-through` : ''}
`

const PublisherListGroup = ({allow = "false", children, bared = "false"}) => {
  if (allow) {
    return (<BarableListItemSpaned bared={bared}> <span style={{color: 'green'}}><Icon icon="allow"/></span> {children}</BarableListItemSpaned>)
  } else {
    return (<BarableListItemSpaned bared={bared}> <span style={{color: 'red'}}><Icon icon="ban"/></span> {children}</BarableListItemSpaned>)
  }
}

const PublisherFilter = ({disabled, useParentFormRef, ...props }) => {
  const { t } = useTranslation();
  const { dataVendorKey } = useParams()
  const {data: vendor = {}} = useGetDataVendorQuery(dataVendorKey)
  const parentFormRef = useParentFormRef("publisher_filters")
  const [publisher_filters,] = usePropState(props.publisher_filters);

  const {formData, setFormData, getInputProps, validated} = useForm({
    defaultObject: publisher_filters,
    initialValues: {
      data_product_overide: false,
      global: {},
      industry: {},
      limitation_bypass: false,
      vendor: {},
      data_product: {},
      publisher_restriction_blacklist: false,
      publisher_restriction_ids: [],
    },
    parentFormRef: parentFormRef,
    disabled: disabled,
    preProcess: (data) => {
      if (formData.data_product_overide) {
        return formData
      } else {
        return { ...formData, publisher_restriction_ids: [] }
      }
    }
  })

  const {data: publishers = []} = useGetPublishersQuery()

  const publisherList = useMemo( ()=>( publishers.map((p) => ( { label: p.name, value: p.id } ) )), [publishers])
  const dataProductFilter = useMemo( ()=>( formData.data_product_overide ), [formData])
  const globalList = useMemo( ()=>( get(formData, 'global.list', []) ), [formData])
  const globalDeny = useMemo( ()=>( get(formData, 'global.deny', false) ), [formData])
  const industryList = useMemo( ()=>( get(formData, 'industry.list', []) ), [formData])
  const industryDeny = useMemo( ()=>( get(formData, 'industry.deny', false) ), [formData])
  const vendorList = useMemo( ()=>( get(formData, 'vendor.list', []) ), [formData])
  const vendorDeny = useMemo( ()=>( get(formData, 'vendor.deny', false) ), [formData])

  return ( <>
    <FormGroup
      input={CustomSwitch}
      label={t("stream.publisherFilter.productFilter")}
      {...getInputProps("data_product_overide")}
    />
    { globalList.length > 0 &&
        <Block title={t("stream.publisherFilter.global")}>
          <FormGroup
            input={CustomSwitch}
            label={t("stream.publisherFilter.globalByPass")}
            {...getInputProps("limitation_bypass")}
            />
          <ListGroup>
            {globalList.map((p)=>(
                <PublisherListGroup key={p.id} allow={!globalDeny} bared={getInputProps("limitation_bypass").value.toString()}>{p.name}</PublisherListGroup>
              )
            )}
          </ListGroup>
        </Block>
    }
    { !dataProductFilter && industryList.length > 0 &&
        <Block title={t("stream.publisherFilter.industry") + " : " + vendor.industry}>
          <ListGroup>
            {industryList.map((p)=>(
              <PublisherListGroup key={p} allow={!industryDeny}>{p.name}</PublisherListGroup>
              )
            )}
          </ListGroup>
        </Block>
    }
    {!dataProductFilter && vendorList.length > 0 &&
        <Block title={t("stream.publisherFilter.vendor") + " : " + vendor.name}>
          <label>{t("dataVendor.blacklist")} : { vendorDeny ? t("dataVendor.exclude") : t("dataVendor.only")  }</label>
          <ListGroup>
            {vendorList.map((p)=>(
                <PublisherListGroup key={p} allow={!vendorDeny}>{p.name}</PublisherListGroup>
              )
            )}
          </ListGroup>
        </Block>
    }
    {dataProductFilter &&
      <Block title={t("stream.publisherFilter.dataProduct")}>
        {<FormGroup
          label={t("dataVendor.blacklist")}
          placeholder={t("pleaseSelect")}
          { ...getInputProps("publisher_restriction_blacklist")}

          >
          <Select isClearable={true}>
            <Option value={true} key="blacklist_true">{t("dataVendor.exclude")}</Option>
            <Option value={false} key="blacklist_false">{t("dataVendor.only")}</Option>
          </Select>
        </FormGroup>}
        <FormGroup
          label={t("dataVendor.publishers")}
          placeholder={t("pleaseSelect")}
          { ...getInputProps("publisher_restriction_ids")}
          >
          <Select
            isMulti
            name="publisher_ids"
            options={publisherList}
          />
        </FormGroup>
      </Block>
    }
  </> );
}

export default PublisherFilter;